module.exports = __webpack_public_path__ + "media/images/team/CatarinaSantos-974afdb4b6a85f3de63d3d9610cb7575.png";